export const SUPPORTED_CURRENCIES = ['SEK', 'EUR', 'USD', 'GBP', 'NOK', 'DKK', 'CHF', 'CAD', 'AUD', 'JPY'] as const;
export type SupportedCurrency = typeof SUPPORTED_CURRENCIES[number];
